import React, { useContext, useMemo, useState } from "react";
import { AccountContext } from "./AccountContext";
import { DateUtils as D } from 'simple-utils';
import { Modal, useModalHide } from "../components/Modal";
import { logEvent } from "../ga/ga-event-logger";

function R(str:string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

export function translatePeriod(period:string){
    if(!period) return "Mês Atual";
    if(period.match(/(\d{4})-(\d{2})/)){
        var year = RegExp.$1;
        return  `${R(D.monthName(D.parseDate(period + "-01"), true))}. ${year}`
    }
    return period;
}


export function buildPeriodList(interval = 11){
    var result = [""];
    var date = new Date();
    for(var i = 1; i <= interval; i++){
        date = D.prevMonth(date);
        result.push(D.asString(date).replace(/-\d+$/, ""));
    }

    return result;
}

function PeriodSelector(){
    const {period, dispatch} = useContext(AccountContext);
    const hide = useModalHide();
    const periodList = useMemo(buildPeriodList, []);

    async function onChange(newPeriod:string){
        await hide();
        if(newPeriod)
            logEvent({type: "change_period", params: {period: newPeriod}})

        dispatch({type:"setPeriod", payload: newPeriod})
        dispatch({type:"setLoading", payload: true})
    }
    
    return (<>
        <b className="d-block mb-2">Período</b>
        <select className="form-control mb-4" value={period || ""} onChange={(e) => onChange(e.target.value)}>
            {periodList.map(e => <option value={e}>{translatePeriod(e)}</option>)}
        </select>
    </>)
}


export function PeriodSelectorButton(){
    const [show, setShow] = useState(false);

    return <>
        <button className="btn btn-secondary mb-2 me-2" onClick={() => setShow(true)}><i className="fa fa-clock"></i> Mudar Período</button>
        {show && <Modal className="modal-primary" onHide={() => setShow(false)} title="Escolher Período"><PeriodSelector /></Modal>}
    </>


}


export function PeriodLabel({short = false}:{short?:boolean}){
    const {period} = useContext(AccountContext);
    if(!period) return null;
    if(short) return <div className="fw-normal mb-2"><i className="far fa-clock me-2"></i> {translatePeriod(period)}</div>
    return <p className="mb-4"><i className="far fa-clock"></i> Período selecionado: <b>{translatePeriod(period)}</b></p>
}